import actions from "./actions";
import mutations from "./mutations";
import getters from "./getters";

export default {
  state: {
    isActive: false,
    user: null,
    userPhoto: null,
    rappyPayMessage: null,
    universityVariables: [],
    questions: [],
    pseBanks: [],
    currentAddress: null,
    currentCityZone: null,
    currentProgram: null,
    traits: null,
    currentPaymentMethod: null,
    pseInformation: null,
    boughtProducts: [],
    acceptanceToken: null,
    recentProducts: [],
    isOnDemandValid: null,
  },
  mutations,
  actions,
  getters,
};
